<template>
  <el-card class="card-wrap" shadow="hover">
    <div @click="$emit('click', data.gasId)">
      <p class="card-title">{{ data.activeName }}</p>
      <p class="time"><span class="name-size">开始时间：</span>{{ data.startTime }}</p>
      <p class="time"><span class="name-size">结束时间：</span>{{ data.endTime }}</p>
      <p class="time" v-if="data.courierNumber"><span class="name-size">快递单号：</span>{{ data.courierNumber }}</p>
      <!-- 状态 -->
      <div class="g-flex-c status" :class="actived">
        <span class="point"></span>
        <span>{{ statusTextList[data.activeStatus] }}</span>
      </div>

      <!-- 分割线 -->
      <!-- <el-divider v-if="data.activeType === 7 && data.activeStatus !== 5"></el-divider> -->

      <div class="g-flex-sb num-wrap">
        <div>
          <!-- <template v-if="data.activeType === 7 && data.activeStatus !== 5">
              <p class="num-size">{{ data.gasDetailNum }}</p>
              <p class="name-size">浏览次数</p>
          </template> -->

          <!-- <template v-if="data.activeType === 5">
            <p class="num-size">{{  data.sendNum }}</p>
            <p class="name-size">发放人数(人)</p>
          </template>
          <template v-else-if="data.activeType === 6">
            <p class="num-size">{{ data.gasDetailNum }}</p>
            <p class="name-size">店铺访问次数(次)</p>
          </template>
          <template v-else-if="data.activeType === 7">
              <p class="num-size">{{ data.gasDetailNum }}</p>
              <p class="name-size">浏览次数</p>
          </template>
          <template v-else-if="data.activeType !== 9">
            <p class="num-size">{{  data.activeType === 4 ? data.customLocation : data.couponNum }}</p>
            <p class="name-size">{{ data.activeType === 4 ? '排位顺序' : data.activeType === 3 ? '领取数量(张)' : '发放数量(张)' }}</p>
          </template> -->
        </div>

        <div>
          <!-- <template v-if="data.activeType === 7 && data.activeStatus !== 5">
            <template>
              <p class="num-size">{{ Math.round(data.newUserAmount) }}</p>
              <p class="name-size">活动新客流水</p>
            </template>
          </template> -->

          <!-- <template v-if="data.activeType === 5">
            <p class="num-size">{{ data.couponUsedUserNum }}</p>
            <p class="name-size">核销人数(人)</p>
          </template>
          <template v-else-if="data.activeType === 7">
            <template v-if="data.activeStatus !== 5">
              <p class="num-size">{{ Math.round(data.newUserAmount) }}</p>
              <p class="name-size">活动新客流水</p>
            </template>
          </template>
          <template v-else-if="data.activeType !== 9">
            <p class="num-size">{{ data.activeType === 4 ? (data.exposureCount || 0) : data.couponUsedNum }}</p>
            <p class="name-size">{{ data.activeType === 4 ? '曝光次数' : '核销数量(张)' }}</p>
          </template> -->
        </div>

        <!-- <div style="min-width: 80px;" v-if="data.activeType === 7 && data.activeStatus !== 5">
          <p class="num-size num-red">{{ Math.round(data.totalAmount) }}</p>
          <p class="name-size">订单总流水(元)</p>
        </div> -->
      </div>

      <div class="g-flex-c" style="margin-top: 10px;">
        <!-- 效果分析：进行中、已结束，召唤司机、会员关怀只有效果分析 -->
        <!-- 冲单已下线状态的不展示效果分析按钮 -->
        <!-- <el-button @click.stop="routeToDetail" v-if="hasEffectStatus.includes(data.activeStatus) && hasEffectType.includes(data.activeType)" type="primary" plain size="small">效果分析</el-button> -->
        <!-- 修改：店铺领劵、油站排序：待开始，站长喊话：待审核 -->
        <!-- <el-button @click.stop="modifyDetail" v-if="(hasUpdateType1.includes(data.activeType) && hasUpdateStatus1.includes(data.activeStatus)) || (hasUpdateType2.includes(data.activeType) && hasUpdateStatus2.includes(data.activeStatus))" class="btn-black" :class="{'btn-disabled': data.activeType === 4 && data.source === 'HELA'}" type="primary" plain size="small">修改</el-button> -->
        <!-- 下线：店铺领劵、油站排序、站长喊话：进行中  -->
        <!-- <el-button @click.stop="updateStatus(4)" v-if="hasAllBtnType.includes(data.activeType) && data.activeStatus === 1" class="btn-red" :class="{'btn-disabled': data.activeType === 4 && data.source === 'HELA'}" type="primary" plain size="small">下线</el-button> -->
        <!-- 取消：店铺领劵、油站排序、站长喊话：待开始、待审核 -->
        <!-- <el-button @click.stop="updateStatus(3)" v-if="hasAllBtnType.includes(data.activeType) && hasCancelStatus.includes(data.activeStatus)" class="btn-grey" type="primary" plain size="small">取消</el-button> -->
        
        <!-- 加油送水 -->
        <el-button size="small" @click="checkReport" v-if="data.activeType === 8 && hasFinishStatus.includes(data.activeStatus)">查看报表</el-button>
        <el-button size="small" v-if="data.activeType !== 12 && hasFinishStatus.includes(data.activeStatus)" @click.stop="routeToDetail">效果分析</el-button>
        <el-button size="small" v-else-if="data.activeType === 12 && hasFinishStatusCD.includes(data.activeStatus)" @click.stop="routeToDetail">效果分析</el-button>
        <el-button class="btn-grey" size="small" v-if="hasOfflineType.includes(data.activeType) && data.activeStatus === 1" @click.stop="offline(4)">下线</el-button>
        <el-button class="btn-grey" size="small" v-if="hasCancelType.includes(data.activeType) && data.activeStatus === 5" @click.stop="offline(3)">取消</el-button>

        <!-- 加油冲单 -->
        <el-button class="btn-grey" size="small" v-if="data.activeType === 12 && data.activeStatus === 5" @click.stop="cancelDialogVisible = true">立即取消</el-button>
      </div>

      <el-dialog
        :title="`${state === 4 ? '下线' : '取消'}确认`"
        :visible.sync="dialogVisible"
        width="400px"
        top="20%"
        :center="true">
        <div class="g-flex-c tips-center">{{ offlineTips }}</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click.stop="dialogVisible = false">算了</el-button>
          <el-button type="primary" @click.stop="userOfflineApi">{{ `确定${state === 4 ? '下线' : '取消'}` }}</el-button>
        </span>
      </el-dialog>

      <!-- 加油冲单取消提示 -->
      <el-dialog
        title="提示"
        :visible.sync="cancelDialogVisible"
        width="30%"
        center
        append-to-body>
        <div class="g-flex-c tips-center">确定立即取消该活动吗？</div>
        <div slot="footer" class="dialog_footer">
          <el-button @click="cancelDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="cancelRunAchieve">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </el-card>
</template>
<script>
import { updateActiveState, offline } from '@/api/marketShop'
import { offlineShouts, offlineSendWater } from '@/api/marketShop/masterShouts'
import { cancelActive } from '@/api/runAchieve/signUp'

export default {
  name: 'card',
  props: {
    data: Object,
    gasStatus: Number
  },
  inject: ['resetData', 'getListData'],
  data () {
    return {
      statusTextList: {
        1: '进行中',
        2: '已结束',
        3: '已取消',
        4: '已下线',
        5: '待开始',
        6: '待审核',
        7: '未通过'
      },
      // hasEffectStatus: [1, 2, 4], // 有效果分析的状态
      // hasEffectType: [1, 2, 3, 4, 5, 7, 8], // 有效果分析的活动类型
      // hasAllBtnType: [4, 6, 8], // 有所有按钮的活动类型，如果有店铺领券则加上3
      // hasUpdateType1: [4], //  有修改权限的类型
      // hasUpdateStatus1: [5], // 有修改权限的状态
      // hasUpdateType2: [6], //  有修改权限的类型
      // hasUpdateStatus2: [6], // 有修改权限的状态
      // hasCancelStatus: [5, 6] // 有取消权限的状态
      hasEffectType: [7], // 有效果分析的活动类型
      hasOfflineType: [8], // 有下线按钮的活动类型
      hasCancelType: [8], // 有取消按钮的活动类型
      hasFinishStatus: [1,2,4], // 有效果分析、查看报表按钮的状态
      hasFinishStatusCD: [1,2], // 冲单活动有效果分析
      dialogVisible: false,
      cancelDialogVisible: false,
      offlineTips: '确定下线该活动吗',
      state: undefined,
      tysj_activity_type: ''
    }
  },
  computed: {
    actived () {
      return {
        'status1': this.data.activeStatus === 1,
        'status2': this.data.activeStatus === 2 || this.data.activeStatus === 3 || this.data.activeStatus === 7,
        'status4': this.data.activeStatus === 4,
        'status5': this.data.activeStatus === 5,
        'status6': this.data.activeStatus === 6,
      }
    }
  },
  methods: {
    // 效果分析跳转
    routeToDetail () {
      const { id, activeType, gasId } = this.data
      // if (this.$route.path.indexOf('promotion') !== -1 && this.data.activeType === 7) {
      //   this.$router.push({path: '/promotion/effectAnalyze', query: { activeId: id }})
      //   return
      // }
      // switch (this.data.activeType) {
      //   case 1:
      //     this.$router.push({path: '/dataAnalyze/effectAmbient', query: { activeId: id }})
      //     break
      //   case 2:
      //     this.$router.push({path: '/dataAnalyze/effectGone', query: { activeId: id }})
      //     break
      //   case 3:
      //     this.$router.push({path: '/dataAnalyze/effectCoupon', query: { activeId: id }})
      //     break
      //   case 4:
      //     this.$router.push({path: '/dataAnalyze/effectSort', query: { activeId: id }})
      //     break
      //   case 5:
      //     this.$router.push({path: '/dataAnalyze/effectMember', query: { activeId: id }})
      //     break
      //   case 7:
      //     this.$router.push({path: '/dataAnalyze/effectSpecialPrice', query: { activeId: id }})
      //     break
      // }
      
      this.$track.clickEvent('详情', '1632832588', {
        tysj_activity_type: this.tysj_activity_type,
        tysj_trade_type: 1
      })
      // 天天特价、限时秒杀、加油送水
      this.$router.push({path: '/promotion/dataDetail', query: { activeId: id, activeType, gasId, gasStatus: this.gasStatus }})

    },
    // 修改跳转
    modifyDetail () {
      if (this.validSource()) return
      const { id } = this.data
      switch (this.data.activeType) {
        case 3:
          this.$router.push({path: '/dataAnalyze/gasCoupon', query: { activeId: id }})
          break
        case 4:
          this.$router.push({path: '/dataAnalyze/gasSort', query: { activeId: id }})
          break
        case 6:
          this.$router.push({path: '/dataAnalyze/stationMasterShouts', query: { activeId: id }})
          break
      }
    },
    // 更新状态
    updateStatus (state) {
      if (this.validSource()) return
      this.$confirm(`确定${state === 4 ? '下线' : '取消'}吗`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        switch (this.data.activeType) {
          case 4:
            this.offlineOrder(state)
            break
          case 6:
            this.offlineShouts(state)
            break
          default:
            this.offlineShop(state)
        }
      }).catch(() => {
        return
      })
    },
    // 校验来源，赫拉不可操作
    validSource () {
      const { source, activeType } = this.data
      if (source === 'HELA' && activeType === 4) {
        this.$alert('当前活动为运营配置，无操作权限', '提示', {
          confirmButtonText: '确定'
        })
        return true
      }
      return false
    },
    // 下线或取消店铺领劵
    async offlineShop (state) {
      try {
        const { code, message } = await updateActiveState({ activeId: this.data.id, state })
        if (code !== 200) {
          this.$message({
            message,
            type: 'error'
          })
          return
        }
        this.$message({
          message: `${state === 4 ? '下线成功' : '取消成功'}`,
          type: 'success'
        })
        this.resetData(this.data.activeType)
        this.getListData(this.data.activeType)
      } catch (error) {
        console.log(error)
      }
    },
    // 下线或取消油站排序
    async offlineOrder (state) {
      try {
        const { code, message } = await offline({ configId: this.data.id, gasId: this.data.gasId })
        if (code !== 200) {
          this.$message({
            message,
            type: 'error'
          })
          return
        }
        this.$message({
          message: `${state === 4 ? '下线成功' : '取消成功'}`,
          type: 'success'
        })
        this.resetData(this.data.activeType)
        this.getListData(this.data.activeType)
      } catch (error) {
        console.log(error)
      }
    },
    // 下线或取消站长喊话
    async offlineShouts (state) {
      try {
        const { code, message } = await offlineShouts({ activityId: this.data.id })
        if (code !== 200) {
          this.$message({
            message,
            type: 'error'
          })
          return
        }
        this.$message({
          message: `${state === 4 ? '下线成功' : '取消成功'}`,
          type: 'success'
        })
        this.resetData(this.data.activeType)
        this.getListData(this.data.activeType)
      } catch (error) {
        console.log(error)
      }
    },
    // 下线或取消送水活动
    offline (state) {
      this.$track.clickEvent('取消', '1632832588', {
        tysj_activity_type: this.tysj_activity_type,
        tysj_trade_type: state - 1
      })
      
      this.state = state
      this.dialogVisible = true
      this.offlineTips = `确定${state === 4 ? '下线' : '取消'}该活动吗`
    },
    // 取消加油冲单
    async cancelRunAchieve () {
      try {
        const {code} = await cancelActive({activeId: this.data.id})
        if (code !== 200) return
        this.$message.success('取消成功')
        this.resetData(this.data.activeType)
        this.getListData(this.data.activeType)
      } catch (error) {
        console.log(error)
      }
    },
    async userOfflineApi () {
      try {
        const {code} = await offlineSendWater({activityId: this.data.id})
        if (code !== 200) return
        this.$message({
          message: `${this.state === 4 ? '下线成功' : '取消成功'}`,
          type: 'success'
        })
        this.dialogVisible = false
        this.resetData(this.data.activeType)
        this.getListData(this.data.activeType)
      } catch (error) {
        console.log(error)
      }
    },
    checkReport () {
      this.$track.clickEvent('查看报表', '1632832588', {
        tysj_activity_type: this.tysj_activity_type,
        tysj_trade_type: 4
      })

      this.$router.push({ path: '/bill/plantformBill' })
    }
  },
  created () {
    switch (this.data.activeType) {
      case 7:
        this.tysj_activity_type = 1
        break
      case 8:
        this.tysj_activity_type = 0
        break
      case 9:
        this.tysj_activity_type = 2
        break
      case 11:
        this.tysj_activity_type = 3
        break
    }
  }
}
</script>
<style lang="less" scoped>
  /deep/.el-card__body {
    padding: 20px 15px;
  }
  /deep/.el-divider--horizontal {
    margin: 16px 0 0 0;
  }
  .card-wrap {
    position: relative;
    margin-top: 10px;
    cursor: pointer;
    .card-title {
      width: calc(~'100% - 80px');
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
      font-size: 15px;
      font-weight: 600;
      color: #333333;
      margin-top: 0;
    }
    .time {
      font-size: 12px;
      color: #666666;
    }
    .status {
      width: 60px;
      height: 28px;
      border-radius: 14px;
      position: absolute;
      top: 12px;
      right: 12px;
      font-size: 12px;
      .point {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 3px;
        margin-right: 5px;
      }
    }
    .num-wrap {
      div {
        flex: 1;
        margin-right: 5px;
        text-align: center;
        &:last-child {
          margin-right: 0;
        }
        .num-size {
          font-size: 18px;
          font-weight: bold;
          color: #333333;
        }
        .num-red {
          color: #FF0000;
        }
      }
    }
    .name-size {
      font-size: 12px;
      color: #999999;
    }
    .g-flex-c /deep/.el-button {
      width: 85px;
      height: 32px;
      color: #4765F9;
      background: #fff;
      border-radius: 4px;
      border-color:#4765F9;
      &.btn-red {
        color: #FF2929;
        border-color: #FF857D;
      }
      &.btn-black {
        color: #4765F9;
        border-color: #4765F9;
      }
      &.btn-grey {
        color: #666666;
        border-color: #CCCCCC;
      }
      &.btn-disabled {
        color: #aaaaaa;
        border-color: #ccc;
      }
    }
    .tips-center {
      height: 60px;
    }
    .dialog-footer /deep/.el-button {
      width: 120px;
    }
  }
  .status1 {
    background: #EEF3FF;
    border: 1px solid #D1DEFF;
    color: #4B7EFE;
    .point {
      background: #768DFF;
    }
  }
  .status2 {
    background: #F1F1F1;;
    border: 1px solid #EDEDED;
    color: #8D8D8D;
    .point {
      background: #A5A5A5;
    }
  }
  .status4 {
    background: #FFF2F2;
    border: 1px solid #FFE4E4;
    color: #FF6161;
    .point {
      background: #FF5A5A;
    }
  }
  .status5 {
    background: #FFF8E8;
    border: 1px solid #FFF4E0;
    color: #FF9D09;
    .point {
      background: #FFAF35;
    }
  }
  .status6 {
    background: #FFF4E0;
    border: 1px solid #FFF4E0;
    color: #FF9D09;
    .point {
      background: #FFAF35;
    }
  }
</style>